import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import all page components
import AacsbRawMetricsPage from "./components/AacsbRawMetricsPage";
import PersonalInfo from "./pages/personal_info";
import ResearchProfile from "./pages/ResearchProfile";
import Education from "./pages/Education";
import AcademicExperience from "./pages/AcademicExperience";
import AcademicAdministrativeRole from "./pages/AcademicAdministrativeRole";
import ProfessionalCertification from "./pages/ProfessionalCertification";
import IndustryExperience from "./pages/IndustryExperience";
import OrganizationalMembership from "./pages/OrganizationalMembership";
import Book from "./pages/Book";
import BookChapters from "./pages/BookChapters";
import JournalPublications from "./pages/JournalPublications";
import ConferenceProceeding from "./pages/ConferenceProceeding";
import ConferenceSessionChair from "./pages/ConferenceSessionChair";
import IntellectualContributions from "./pages/IntellectualContributions";
import ReviewActivity from "./pages/ReviewActivity";
import EditorialService from "./pages/EditorialService";
import ResearchSupervision from "./pages/ResearchSupervision";
import ResearchGrant from "./pages/ResearchGrant";
import SocialService from "./pages/SocialService";
import EventWorkshop from "./pages/EventWorkshop";
import CommitteeService from "./pages/CommitteeService";

// Landing, Dashboard, Admin Dashboard, Login, Register
import Landing from "./components/Landing";
import Dashboard from "./components/Dashboard";
import AdminDashboard from "./components/AdminDashboard";
import Login from "./components/Login";
import Register from "./components/Register";
import ResetPassword from "./components/ResetPassword";
import FacultyPage from "./pages/FacultyPage";
import BrandMembership from "./pages/BrandMembership";
import Awards from "./pages/Awards";
import CourseCoordination from "./pages/CourseCoordination";

//NEW ADDITIONS

import NewProgramDevelopment from "./pages/NewProgramDevelopment";
import NewDegreeCourseDevelopment from "./pages/NewDegreeCourseDevelopment";
import ProfessionalCertificateDevelopment from "./pages/ProfessionalCertificateDevelopment";
import ConsultationServices from "./pages/ConsultationServices";
import OpEd from "./pages/OpEd";
import IndustryReport from "./pages/IndustryReport";
import CasePublications from "./pages/CasePublications";
import ResearchGrantProposalReviewed from "./pages/ResearchGrantProposalReviewed";
import AcademicEventOrganized from "./pages/AcademicEventOrganized";
import TextBook from "./pages/TextBook";
import TradeJournal from "./pages/TradeJournal";
import BusinessOwnership from "./pages/BusinessOwnership";
import ContributionToMedia from "./pages/ContributionToMedia";
import SpeechDelivered from "./pages/SpeechDelivered";
import TrainingDelivered from "./pages/TrainingDelivered";
import BookReviewIntl from "./pages/BookReviewIntl";
import BookReviewLocal from "./pages/BookReviewLocal";
import AcademicPolicyContribution from "./pages/AcademicPolicyContribution";
import InternationalAcademicContribution from "./pages/InternationalAcademicContribution";
import PolicyAdvisoryRole from "./pages/PolicyAdvisoryRole";
import PublicInterestEngagement from "./pages/PublicInterestEngagement";
import IntellectualProperty from "./pages/IntellectualProperty";
import CommunityOutreach from "./pages/CommunityOutreach";
import PolicyBriefs from "./pages/PolicyBriefs";
import TestBackend from "./components/TestBackend";

// Error Boundary
import ErrorBoundary from "./components/ErrorBoundary";

//AACSB
import AacsbDashboard from "./components/AACSBdashboard";
import AACSBdetails from "./components/AACSBdetails";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/admin_dashboard"
          element={
            <ErrorBoundary>
              <AdminDashboard />
            </ErrorBoundary>
          }
        />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route
          path="/faculty/:id"
          element={
            <ErrorBoundary>
              <FacultyPage />
            </ErrorBoundary>
          }
        />
        <Route path="/personal_info" element={<PersonalInfo />} />
        <Route path="/research-profile" element={<ResearchProfile />} />
        <Route path="/education" element={<Education />} />
        <Route path="/academic-experience" element={<AcademicExperience />} />
        <Route
          path="/academic-administrative-role"
          element={<AcademicAdministrativeRole />}
        />
        <Route
          path="/professional-certification"
          element={<ProfessionalCertification />}
        />
        <Route path="/industry-experience" element={<IndustryExperience />} />
        <Route
          path="/organizational-membership"
          element={<OrganizationalMembership />}
        />
        <Route path="/book" element={<Book />} />
        <Route path="/book-chapters" element={<BookChapters />} />
        <Route path="/journal-publications" element={<JournalPublications />} />
        <Route
          path="/conference-proceeding"
          element={<ConferenceProceeding />}
        />
        <Route
          path="/conference-session-chair"
          element={<ConferenceSessionChair />}
        />
        <Route path="/aacsb-raw/:facultyId" element={<AacsbRawMetricsPage />} />
        <Route
          path="/intellectual-contributions"
          element={<IntellectualContributions />}
        />
        <Route path="/review-activity" element={<ReviewActivity />} />
        <Route path="/editorial-service" element={<EditorialService />} />
        <Route path="/research-supervision" element={<ResearchSupervision />} />
        <Route path="/research-grant" element={<ResearchGrant />} />
        <Route path="/social-service" element={<SocialService />} />
        <Route path="/event-workshop" element={<EventWorkshop />} />
        <Route path="/committee-service" element={<CommitteeService />} />
        <Route path="/awards" element={<Awards />} />

        <Route path="/new-program" element={<NewProgramDevelopment />} />
        <Route
          path="/new-degree-dev"
          element={<NewDegreeCourseDevelopment />}
        />
        <Route
  path="/course-coordination"
  element={<CourseCoordination />}
/>
        <Route
          path="/pro-certificate-dev"
          element={<ProfessionalCertificateDevelopment />}
        />
        <Route
  path="/book-review-intl"
  element={<BookReviewIntl />}
/>

<Route
  path="/book-review-local"
  element={<BookReviewLocal />}
/>
        <Route path="/consultation" element={<ConsultationServices />} />
        <Route path="/op-ed" element={<OpEd />} />
        <Route path="/industry-report" element={<IndustryReport />} />
        <Route path="/case-publication" element={<CasePublications />} />
        <Route
          path="/grant-proposal-reviewed"
          element={<ResearchGrantProposalReviewed />}
        />

        <Route path="/event-organized" element={<AcademicEventOrganized />} />

        <Route path="/textbook" element={<TextBook />} />
        <Route path="/trade-journal" element={<TradeJournal />} />
        <Route path="/business-owner" element={<BusinessOwnership />} />
        <Route path="/brand-member" element={<BrandMembership />} />
        <Route path="/contribution-media" element={<ContributionToMedia />} />
        <Route path="/speech-delivered" element={<SpeechDelivered />} />
        <Route path="/training-delivered" element={<TrainingDelivered />} />

        <Route
          path="/aacsb/:id"
          element={
            <ErrorBoundary>
              <AacsbDashboard />
            </ErrorBoundary>
          }
        />

        <Route
          path="/aacsb-details/:id"
          element={
            <ErrorBoundary>
              <AACSBdetails />
            </ErrorBoundary>
          }
        />

        <Route
          path="/academic-policy"
          element={<AcademicPolicyContribution />}
        />
        <Route
          path="/international-academic"
          element={<InternationalAcademicContribution />}
        />
        <Route path="/policy-advisory" element={<PolicyAdvisoryRole />} />
        <Route path="/public-interest" element={<PublicInterestEngagement />} />
        <Route
          path="/intellectual-property"
          element={<IntellectualProperty />}
        />
        <Route path="/community-outreach" element={<CommunityOutreach />} />
        <Route path="/policy-brief" element={<PolicyBriefs />} />
        <Route path="/test" element={<TestBackend />} />
      </Routes>
    </Router>
  );
};

export default App;
